// extracted by mini-css-extract-plugin
module.exports = {"button":"_33-ZQ","wrapper":"_2XEoD","label":"_29v1f"};